// Quick Search: Entry
// 

JLM.MD.MenuSearchEntry = function( container, data, is_set ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.id = data[0];
	INSTANCE.name = data[1];
	
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let title, link;
	
	// Talent properties
	let talent_divisions = data[2],
		talent_image = talent_divisions[ Object.keys( talent_divisions )[0] ];
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let item, details, divisions;
		
		// Settings
		let links = [];
		
		// Create structure
		item = $('<li />').appendTo( container );
		link = $('<a />').appendTo( item );
		details = $('<div />').appendTo( item );
			title = $('<h6>' + INSTANCE.name + '</h6>').appendTo( details );
			divisions = $('<ul class="divisions" />').appendTo( details );
		
		// Fill with division links
		if ( talent_divisions[ JLM.NS.DIVISION_ACTORS ] ) {
			let type_division = JLM.NS.DIVISION_ACTORS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Actor</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_VOICES ] ) {
			let type_division = JLM.NS.DIVISION_VOICES,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Voice</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_CONTENT_CREATORS ] ) {
			let type_division = JLM.NS.DIVISION_CONTENT_CREATORS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Content Creator</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_BRAND_AMBASSADORS ] ) {
			let type_division = JLM.NS.DIVISION_BRAND_AMBASSADORS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Brand Ambassador</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_PRESENTERS ] ) {
			let type_division = JLM.NS.DIVISION_PRESENTERS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Presenter</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_MCS_ENTERTAINERS ] ) {
			let type_division = JLM.NS.DIVISION_MCS_ENTERTAINERS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">MC &amp; Entertainer &amp; Speaker</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		if ( talent_divisions[ JLM.NS.DIVISION_WRITERS_DIRECTORS ] ) {
			let type_division = JLM.NS.DIVISION_WRITERS_DIRECTORS,
				url_division = JLM.MT.generateTalentProfileLink( type_division, INSTANCE.name );
			$('<li><a href="' + url_division + '" data-division="' + type_division + '">Writer &amp; Director</a></li>').appendTo( divisions );
			links.push({ division: type_division, url: url_division });
		}
		
		// Set headshot link
		if ( links.length ) {
			link.attr('data-division', links[0].division).attr('href', links[0].url);
		}
		
		// Load image
		let image_src = '/img/' + INSTANCE.id + '/thmb/1/' + talent_image;
		loadImage( image_src, is_set );
		
		// Events
		link.on('click', function() {
			JLM.MT.trackEvent('Click', {
				event_category: 'Talent Search',
				event_label: JSON.stringify({
					talent: INSTANCE.id,
					division: $(this).attr('data-division')
				})
			});
		});
		$('a', divisions).on('click', function() {
			JLM.MT.trackEvent('Click', {
				event_category: 'Talent Search',
				event_label: JSON.stringify({
					talent: INSTANCE.id,
					division: $(this).attr('data-division')
				})
			});
		});
	}
	
	
	// Load image process
	// 
	function loadImage( image_src, instant_load ) {
		let image = new Image();
		image.onload = function() {
			let image_span = $('<span />').css('background-image', 'url(' + image_src + ')').appendTo( link );
			if ( instant_load ) {
				image_span.addClass('reveal instant');
			} else {
				setTimeout(function() {
					image_span.addClass('reveal');
				}, 10);
			}
		};
		image.onerror = function() {
			// Fallback image?
		};
		image.src = image_src;
	}
	
	
	// Methods: Private _________________________________________________________
	
	// Highlight matched part of name
	// 
	INSTANCE.highlightName = function( regex ) {
		let talent_name = INSTANCE.name.replace(regex, '<em>$1</em>');
		title.html( talent_name );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};